export const constants = {
  bold: [
    {
      name: 'Light',
      value: '100'
    },
    {
      name: 'Regular',
      value: '400'
    },
    {
      name: 'Bold',
      value: '700'
    }
  ]
};

export const units = {
  pixel: 'px',
  percentage: '%',
  seconds: 'sec',
  milliseconds: 'ms',
  aspectRatio: 'W/H'
};
